import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderEn = () => {
    return (
        <HighlightedText
            text="CONGRATULATIONS!"
            highlights={[{ word: 'CONGRATULATIONS!' }]}
            className={styles.text_header}
        />
    )
}

export const TextContentEn = () => {
    return (
        <HighlightedText
            text="YOU HAVE WON 400 FREESPINS"
            highlights={[{ word: '400 FREESPINS' }]}
            breakAfterWords={['WON']}
            className={styles['text_content--SECOND']}
        />
    )
}
